import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import styles from './GridArticleCollection.module.scss'
import AppContext from '@/types/context'

export interface GroupGridProps {
  children: Array<PartialWidgetContext>
}

const GridArticleCollection = ({ item, context }: { item: GroupGridProps; context: AppContext }) => {
  return (
    <div className={styles.article}>
      {item.children.map((widget: PartialWidgetContext, index) => {
        return <Partials key={index} item={widget as any} context={context} />
      })}
    </div>
  )
}

export default GridArticleCollection
